import * as Backbone from "backbone";
import { DashboardRange } from "./DashboardRange";
import * as _ from 'lodash'
import { Utils } from "../common/utils";

export class DashboardChannel extends Backbone.Model {

    getRange(channelValue?): DashboardRange {
        var value = channelValue ? channelValue : this.get('channel_converted_value');
        if (value == null || !this.get('rangesList') || this.get('rangesList').length < 2) return this.getDefaultRange();

        for (var r of this.get('rangesList')) {
            var range = new DashboardRange(r);
            if (range.inRange(value)) return range;
        }
    }

    getRangeByValue(value): DashboardRange {
        if (value == null || !this.get('rangesList') || this.get('rangesList').length < 2) return this.getDefaultRange();

        for (var r of this.get('rangesList')) {
            var range = new DashboardRange(r);
            if (range.inRange(value)) return range;
        }
    }

    getDefaultRange(): DashboardRange {
        const rangesList = this.get('rangesList');
        const defaultRange = new DashboardRange({
            name: 'Good',
            description: 'Value within threshold',
            color: Utils.colors.green,
            min: null,
            max: null,
            is_default: true,
        });

        if (!rangesList) {
            return defaultRange;
        } else {
            var range = _.find(this.get('rangesList'), { is_default: true });
            if (range) {
                return new DashboardRange(range);
            } else {
                return defaultRange;
            }
        }
    }

}
DashboardChannel.prototype.idAttribute = 'dashboard_channel_id';



// WEBPACK FOOTER //
// ./srv/public/js/models/DashboardChannel.ts